import React, { useEffect, useState, useCallback } from 'react';
import moment from 'moment';
import { message, Tooltip } from '@drip/drip-design';
import { queryDucc } from '@/apis/marketingField/materialCollection';
import { getQuery } from '@/common/utils';
import Dongdong from '@/components/dongdong';
import { getRootPath } from '../util';
import './index.less';

interface PalletItem {
  name: string;
  slogo: string;
  creator: string;
  description: string;
  scene: string;
  levelImg: string;
  poolType: string;
  newFlagStart?: string;
  newFlagEnd?: string;
}

interface Iprops {
  handlePalletSelect: (poolType: number) => void;
  handleShowNew?: (flag: boolean) => void;
  embedScene?: string;
  isDaily?: boolean;
}

const prefix = 'pallet-card-select';
const PalletCardSelect = (props: Iprops) => {
  const [palletList, setPalletList] = useState<PalletItem[]>([]);
  const [scene, setScene] = useState<string>('');
  const { handlePalletSelect, handleShowNew, embedScene, isDaily } = props;

  const handleScene = useCallback(() => {
    if (isDaily) {
      setScene('daily');
      return;
    }
    if (embedScene === 'theme') {
      setScene('theme');
      return;
    }
    setScene(getRootPath() === 'platform-marketing' ? 'platform' : 'channel');
  }, [embedScene, isDaily]);

  useEffect(() => {
    queryDucc({ duccKey: 'sourceCms.yth.pallet.selection' })
      .then((res) => {
        const { ret, msg, data } = res;
        if (ret === '0') {
          try {
            const data1 = JSON.parse(data?.data) || [];
            setPalletList(data1);
            if (handleShowNew && data1.length) {
              let end = data1[0]?.newFlagEnd || new Date();
              let diff = moment(new Date(), 'YYYY-MM-DD').diff(moment(end, 'YYYY-MM-DD'), 'days');
              handleShowNew(diff < 0);
            }
          } catch (error) {
            setPalletList([]);
          }
        } else {
          throw msg || '促销选品配置信息获取错误！';
        }
      })
      .catch((ex) => {
        message.error(ex);
        setPalletList([]);
      });
    handleScene();
  }, [handleShowNew, handleScene]);

  const activityId = getQuery('activityId') || '';
  const planCode = getQuery('planCode') || '';

  return (
    <div className={`${prefix}-wrapper`}>
      {palletList?.map((item, index) => (
        <div className={`${prefix}-item`} key={`${item.poolType}-index`}>
          <div className="name">
            <img className="img" src={item.slogo} alt="slogo" /> <span>{item.name}</span>
          </div>
          <div className="creator-scene">
            创建人：
            <Dongdong name={item.creator} erp={item.creator} />
          </div>
          <Tooltip title={item.description} placement="right">
            <p className="description">{item.description}</p>
          </Tooltip>
          <div className="creator-scene">
            展示场景：<span>{item.scene}</span>
          </div>

          <div
            className={`${prefix}-footer`}
            data-yxlogtag={`pallet_selection|||${JSON.stringify(
              embedScene === 'theme'
                ? { palletName: item.name, activityId: planCode, scene: scene }
                : { palletName: item.name, activityId: activityId, scene: scene }
            )}`}
            onClick={() => handlePalletSelect(Number(item.poolType))}
          >
            去选品
          </div>
          <div className="level-icon">
            <img src={item.levelImg} alt="等级" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default PalletCardSelect;
